import styled from 'styled-components';

export const HotelLayoutTag = styled.main`
  padding-bottom: 55px;
  overflow: hidden;

  @media(min-width: 768px) {
    padding-bottom: 20px;
  }
`;

export const HotelTwoColumnLayout = styled.main`
`;

export const HotelTwoColumnContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1210px;
  width: 100%;
  margin: 0 auto;
  padding: 0 40px;
  padding-bottom: 50px;
`;

export const HotelLayoutContent = styled.div`
  max-width: 750px;
  width: 100%;
`;

export const HotelLayoutAside = styled.aside`
  max-width: 315px;
  z-index: 0;
  width: 100%;
  margin-left: 50px;
`;

export const HotelLayoutSmallTwoColumns = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
`;

export const HotelLayoutSmallColumn = styled.div`
  //padding: 8px 35px;
`;

export const HotelLayoutDesktopTwoColumns = styled.section`
  display: flex;
  justify-content: space-between;
  padding: 0 25px;

  @media(min-width: 768px) {
    padding: 0 40px;
  }

  @media(min-width: 1024px) {
    padding: 0;
  }
`;

export const HotelLayoutDesktopColumn = styled.div`
  padding: 20px;
  width: 50%;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;
